/**
 * Available language options for the application
 * Each language has:
 * - value: ISO language code
 * - label: Display name in its native language
 * - flag: Path to the flag image
 */
export const languageOptions = [
  {
    value: "en",
    label: "English",
    flag: "us.svg",
  },
  {
    value: "pt-BR",
    label: "Português",
    flag: "br.svg",
  },
  {
    value: "es",
    label: "Español",
    flag: "es.svg",
  },
  {
    value: "de",
    label: "Deutsch",
    flag: "de.svg",
  },
  {
    value: "fr",
    label: "Français",
    flag: "fr.svg",
  },
  /**
  {
    value: "it",
    label: "Italiano",
    flag: "/images/flags/it.svg",
  },
  {
    value: "ja",
    label: "日本語",
    flag: "/images/flags/jp.svg",
  },
  {
    value: "zh-CN",
    label: "简体中文",
    flag: "/images/flags/cn.svg",
  },
   */
];

/**
 * Default language for the application when no preference is detected
 */
export const defaultLanguage = "en";

/**
 * Map between language codes and their RTL status
 */
export const rtlLanguages = ["ar", "he", "fa", "ur"];

/**
 * Check if a language is RTL
 * @param {string} languageCode - The language code to check
 * @returns {boolean} - True if the language is RTL
 */
export const isRtlLanguage = (languageCode) =>
  rtlLanguages.includes(languageCode);
